<style>
* {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    box-sizing: border-box;
    font-family: PingFang SC;
}
html,
body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    min-height: 100%;
}

ul,
li,
p {
    margin: 0;
    padding: 0;
    list-style: none;
}

p {
    hyphens: auto;
}

img {
    display: block;
}

button {
    border: none;
    outline: none;
}

.ell {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

#app {
    line-height: 1;
    font-family: 'PingFang SC', 'STHeitiSC-Light', 'Helvetica-Light', arial, sans-serif, 'Droid Sans Fallback';
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    font-size: 0.32rem;
    min-height: 100%;
    height: 100%;
}

/* 处理input type = number的上下箭头 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}
input[type='number'] {
    -webkit-appearance: none !important;
    -moz-appearance: textfield !important;
}

.ant-message {
    top: 60% !important;
    font-size: 0.32rem !important;
    width: 80% !important;
    margin: 0 10% !important;
    z-index: 100000000 !important;
}
.ant-message-notice-content {
    padding: 0.1rem 0.16rem !important;
    background-color: #ddd !important;
}
.ant-message-custom-content {
    font-size: 0.28rem;
    line-height: 0.28rem;
    display: flex;
    align-items: center;
    justify-content: center;
}
.ant-message .anticon {
    font-size: 0.24rem !important;
}
.ant-radio-group {
    display: flex !important;
}

.flex {
    display: flex;
}

.flex-r {
    flex-direction: row;
}
.flex-c {
    flex-direction: column;
}
.flex-jc-sa {
    justify-content: space-around;
}
.flex-jc-sb {
    justify-content: space-between;
}
.flex-ac {
    align-items: center;
}
.flex-j {
    justify-content: center;
}
.flex-j-sa {
    justify-content: space-around;
}
.flex-j-sb {
    justify-content: space-between;
}

.flex-a {
    align-items: center;
}
.flex-m {
    align-items: center;
    justify-content: center;
}
.flex-sb {
    justify-content: space-between;
}
.flex-w {
    flex-wrap: wrap;
}

#fc_frame {
    z-index: 200 !important;
}
</style>

<template>
    <div id="app" ref="vueApp" :class="[$i18n.locale]">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive">
                <!-- 这里是会被缓存的视图组件，比如 Home！ -->
            </router-view>
        </keep-alive>

        <router-view v-if="!$route.meta.keepAlive">
            <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
        </router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    components: {},
    data() {
        return {};
    },
    mounted() {
        this.$refs.vueApp.style.disply = 'block';
    }
};
</script>
